<template>
  <div class="container new-box">
    <div class="header clearfix">
      <div class="login-box">
        <span class="nav-sp">
          <img src="../../assets/images/logo1.jpg" alt="">
          <span>四川广智华荣工程项目咨询有限公司</span>
          <em class="em2">Sichuan Guangzhi Huarong Project Consulting Co., Ltd</em>
          <em>规范，专业，服务，创新</em>
        </span>
        <p class="login-iphone">
          <span class="iphone-sp1">咨询电话：</span>
          <span class="iphone-sp2">028-61894045</span>
        </p>

      </div>
      <div class="nav">
       <p class="nav-p">
         <a href="javascript:;" @click="goHome()"><span>官方首页</span> </a>
         <a href="javascript:;"  class="a-hover" @click="goqyjj()"><span>企业简介</span> </a>
         <a href="javascript:;" @click="gozbxx()"><span>招标信息</span> </a>
         <a href="javascript:;" @click="gokffw()"><span>客服服务</span></a>
         <a href="javascript:;"  @click="gogsdt()"><span>公司动态</span></a>
         <a href="javascript:;" @click="gojlyd()"><span>交流园地</span></a>
         <a href="javascript:;" @click="gorczp()"><span>人才招聘</span></a>
         <a href="javascript:;" @click="gobsxt()"><span>报名系统</span></a>
       </p>
      </div>
    </div>
    <!--switch-->
    <div class="switch2 clearfix">
      <img src="../../assets/images/qyjj-ban.jpg" alt="">
    </div>
    <!--switch END-->
    <!--content -->
    <div class="cent clearfix">
        <div class="new-left">
           <ul class="new-ul">
             <li @click="goqyjj()">公司简介</li>
             <li  class="active">企业文化</li>
             <li @click="gorygs()" >荣耀故事</li>
             <li @click="gozzjg()" >组织机构</li>
             <li @click="gofzjg()" >分支机构</li>
           </ul>
        </div>
        <div class="new-right">
            <p class="path"><span @click="goHome()">首页</span>/企业文化</p>
            <p class="p-h3">{{qyjjdata.co_title}}</p>
            <div class="new-center">
               <div v-html="qyjjdata.co_content">

               </div>
            </div>
        </div>
    </div>
    <!--content END-->
    <!--footer-->
   <div class="bottom">
     <div class="bot-left">
       <p class="p1">联系广智华荣</p>
       <p>电子邮箱：406223221@qq.com</p>
       <p>总机：028-61894045</p>
       <p>公司地址：四川省成都市金牛区金周路595号 </p>
       <p>备案号：<a href="https://beian.miit.gov.cn/"  target="_blank">蜀ICP备2021003450号</a></p>
     </div>
     <div class="bot-right">
       <p class="p1"> 微信订阅号：</p>
       <p class="p2"><img src="../../assets/images/wm3.png" alt=""></p>
     </div>
   </div>
   <div class="footer">
     OPYRIGHT (©) 2022 四川广智华荣工程项目咨询有限公司 备案号：<a href="https://beian.miit.gov.cn/"  target="_blank">蜀ICP备2021003450号</a>
   </div>
  </div>
</template>

<script type="text/ecmascript-6">
    import http from '../../http.js'
  export default {
    data() {
      return {
        visible: false,
        activeName2: 'first',
        qyjjdata:"",
      }
    },
    mounted: function() {
         this.getqyjj(2);
    },
    methods: {

      //获取企业简介
      getqyjj(i) {
        var that = this;
        var parameter = {
          sign: this.sign,
          timestamp: this.timestamp,
          type: i
        };
        http.post(this.conf.base_url + '/api/co/index', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error('访问错误');
          } else {
            console.log(res.data.result);
            this.qyjjdata= res.data.result;
          }
        }).catch(e => {
          //..
        })
      },
      goHome:function () {
        this.$router.push({path:'/index/'});
      },
      gogsdt:function () {
        this.$router.push({path:'/gsdt/'});
      },
      gojlyd:function () {
        this.$router.push({path:'/jlyd/'});
      },
      gokffw:function () {
        this.$router.push({path:'/kffw/'});
      },
      goqyjj:function () {
        this.$router.push({path:'/qyjj/'});
      },
      gorczp:function () {
        this.$router.push({path:'/rczp/'});
      },
      gozbxx:function () {
        this.$router.push({path:'/zbxx/'});
      },
      gonewstxt:function () {
        this.$router.push({path:'/newstxt/'});
      },
      gobsxt: function() {
         this.$router.push({path: '/bsxt/' });
      },
      //内页跳转
      goqywh:function () {
        this.$router.push({path:'/qywh/'});
      },
      gofzjg:function () {
        this.$router.push({path:'/fzjg/'});
      },
      gofzjg:function () {
        this.$router.push({path:'/fzjg/'});
      },
      gorygs:function () {
        this.$router.push({path:'/rygs/'});
      },
      gozzjg:function () {
        this.$router.push({path:'/zzjg/'});
      },

    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/qyjj/qywh.vue